import { motion } from 'framer-motion';

import { SABER_BLUE, SABER_GREEN } from '../constants';

function getStreakHeight(i: number): number {
  if (i % 6 === 0) return 3;
  if (i % 3 === 0) return 2;
  return 1;
}

export function HyperspaceBg() {
  return (
    <div className='pointer-events-none absolute inset-0 overflow-hidden' style={{ zIndex: 0 }}>
      <div className='absolute inset-0' style={{ background: `radial-gradient(ellipse 90% 70% at 50% 30%, ${SABER_BLUE}0A, transparent 70%)` }} />
      {Array.from({ length: 40 }).map((_, i) => (
        <motion.div key={`streak-${i}`} className='absolute' style={{ top: `${(i * 7.3) % 100}%`, left: 0, width: 60 + (i % 5) * 40, height: getStreakHeight(i), background: `linear-gradient(to right, transparent, ${i % 2 === 0 ? SABER_BLUE : '#fff'}60, transparent)` }} animate={{ x: ['-20vw', '120vw'], opacity: [0, 0.7, 0] }} transition={{ duration: 2.5 + (i % 4) * 1.2, delay: (i % 8) * 0.9, repeat: Infinity, ease: 'linear' as const }} />
      ))}
      <div className='absolute start-6 top-[5%] h-[30%] w-[3px] opacity-20' style={{ background: `linear-gradient(to bottom, transparent, ${SABER_BLUE}, transparent)`, filter: 'blur(1px)' }} />
      <div className='absolute end-6 top-1/2 h-[28%] w-[3px] opacity-20' style={{ background: `linear-gradient(to bottom, transparent, ${SABER_GREEN}, transparent)`, filter: 'blur(1px)' }} />
    </div>
  );
}
